module.exports = __webpack_public_path__ + "img/ck-logo.0aeefed7.svg";